import React, { useState, useContext } from "react";
import { RootContext } from "../../../RootContextProvider";
// import { useHistory } from "react-router-dom";
import { Button, message, Row, Col, Input, Form } from "antd";
import "./../../addNewLinkRegular/AddNewLinkRegular.css";
import iconDelete from "../../../assets/icons/icon-delete.svg";
import { verticalFormLayout } from "../../../utils/forms";
import { addNewLinkToPage, updateLink, deleteLink } from "../../../utils/links";
import "../ModalLinkCreation.css";
import { FaYoutubeSquare } from "react-icons/fa";
const YoutubeSub = ({
  setModalOpen,
  isEdittingLink,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
}) => {
  const [form] = Form.useForm();

  const [loading] = useState(false);
  //   const [needUpgrade, setNeedUpgrade] = useState(false);
  const { pages } = useContext(RootContext);
  //   let history = useHistory();

  if (isEdittingLink) {
    console.log("editing mode");
    form.setFieldsValue({
      url: linkEditDetails.LinkUrl,
      title: linkEditDetails.LinkTitle,
      embedCode: linkEditDetails.LinkEmbedCode,
    });
  } else {
    console.log("normal mode");
    form.setFieldsValue({
      url: "",
      title: "",
      embedCode: "",
    });
    // form.resetFields();
  }
  const onFinish = async (values) => {
    if (!isEdittingLink) {
      let linkDetails = {
        type: "youtube-sub",
        title: values.title,
        url: values.url,
        embedCode: values.embedCode,
        index: currentLinks ? currentLinks.length : 0,
      };
      await addNewLinkToPage(pages.PageID, linkDetails);

      setRefresh(refresh + 1);
    } else {
      // update link info
      // close modal
      let linkDetails = {
        id: linkEditDetails.LinkID,
        type: linkEditDetails.LinkType,
        title: values.title,
        url: values.url,
        index: linkEditDetails.LinkIndex,
      };
      let isUpdated = await updateLink(pages.PageID, linkDetails);
      if (isUpdated.message) {
        message.success("Lien modifié avec succès");
        setEdittingLink(false);
        setRefresh(refresh + 1);
      } else {
        message.error("Erreur lors de la modification");
      }
    }

    setModalOpen(false);
  };

  const onFinishFailed = async () => {
    console.log("Bugggg");
  };

  const delLink = async () => {
    let deletedLink = await deleteLink(pages.PageID, linkEditDetails.LinkID);

    if (deletedLink.message) {
      message.success("Bloc supprimé avec succès");
      setRefresh(refresh + 1);
    } else {
      message.error("Erreur lors de la suppression");
    }
    cancelModal();
  };

  const cancelModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setEdittingLink(false);
    }, 200);
  };

  return (
    <div>
      <div className="modal-header">
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <div className="modal-title">
              <FaYoutubeSquare className="icon-modal-title" /> Paramètrez votre
              bloc Sub Youtube
            </div>
          </Col>
          <Col span={2}>
            {isEdittingLink ? (
              <img
                src={iconDelete}
                onClick={() => {
                  delLink();
                }}
                alt="icon delete"
                width="30px"
                style={{ float: "right", cursor: "pointer" }}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>
      <div className="modal-body">
        <Form
          className="form-signup align-left"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          {...verticalFormLayout}
        >
          <Form.Item
            label="Titre"
            name="title"
            maxLength={80}
            rules={[{ required: true, message: "Insérez votre titre" }]}
          >
            <Input
              className="auth-input"
              placeholder="Suivez-moi sur Youtube !"
            />
          </Form.Item>
          <Form.Item
            label="URL de la chaîne Youtube"
            maxLength={300}
            name="url"
            rules={[
              { required: true, message: "Insérez l'url de la chaîne Youtube" },
            ]}
          >
            <Input
              className="auth-input"
              placeholder="hhttps://www.youtube.com/c/aMOODIEsqueezie/"
            />
          </Form.Item>

          <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              className="submit-link"
              htmlType="submit"
              loading={loading}
              size="large"
              // disabled={
              //     !getFieldValue("Email") ||
              //     !getFieldValue("Password") ||
              //     hasErrors(getFieldsError())
              // }
            >
              Sauvegarder
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default YoutubeSub;
